// Recognises the failures webpack raises when a code-split chunk can't be
// loaded: the file 404s because a deploy replaced the hashes while this tab
// still had the old index.html, the request timed out on a slow connection,
// or the browser refused to parse it. Clarity logs these as "Loading chunk N
// failed" and they were the single largest source of the full-page
// "Something went wrong" screen.
export const isChunkLoadError = (error) => {
  if (!error) return false;
  const name = error.name || '';
  const message = error.message || String(error);
  return (
    name === 'ChunkLoadError'
    || /Loading (CSS )?chunk [\w-]+ failed/i.test(message)
    || /Importing a module script failed/i.test(message)
    || /Unexpected token '<'/.test(message)
  );
};

const RELOAD_KEY = 'wg-chunk-reload-at';
// Minimum gap between automatic reloads. A fresh index.html fixes the
// after-deploy case on the first reload; if the chunk is still broken after
// that (older Safari refusing to parse it, say) we must not loop.
export const RELOAD_COOLDOWN_MS = 10 * 60 * 1000;

const lastReloadAt = () => {
  try {
    const raw = sessionStorage.getItem(RELOAD_KEY);
    return raw ? Number(raw) || 0 : 0;
  } catch (e) {
    return 0;
  }
};

/**
 * Reload the page to pick up the current build, at most once per cooldown
 * window. Returns true when a reload was triggered, false when the caller
 * should surface the error instead.
 */
export const reloadOnceForChunkError = () => {
  const now = Date.now();
  if (now - lastReloadAt() < RELOAD_COOLDOWN_MS) return false;
  try {
    sessionStorage.setItem(RELOAD_KEY, String(now));
  } catch (e) {
    // Storage blocked: still reload once; the cooldown just can't be recorded.
  }
  window.location.reload();
  return true;
};
